import BellIcon from '@assets/icons/bell.svg?react'
import cn from 'classnames'
import { GlobalContext, tr } from 'mmfintech-commons'
import { MMButton } from 'mmfintech-portal-commons'
import { useCallback, useContext } from 'react'
import { NotificationsPanel } from './NotificationsPanel'
import styles from './NotificationsPanel.module.scss'
import { NotificationsPanelHeader } from './NotificationsPanelHeader'
import { useNotificationsUnreadCount } from './useNotificationsUnreadCount'

const MAX_BADGE_COUNT = 99

interface NotificationsBellProps {
  enabled?: boolean
  hideBadge?: boolean
}

export const NotificationsBell = ({ enabled = true, hideBadge = false }: NotificationsBellProps) => {
  const { sidebarRightShow } = useContext(GlobalContext)
  const { total } = useNotificationsUnreadCount(enabled)

  const handleOpen = useCallback(() => {
    sidebarRightShow({
      header: <NotificationsPanelHeader />,
      content: <NotificationsPanel />,
      options: {
        size: 'extra-large',
        closeOnClickOutside: true,
        hideCloseIcon: true,
        type: 'rounded'
      }
    })
  }, [sidebarRightShow])

  return (
    <div className={cn(styles['notifications-bell'], 'notifications-bell')}>
      <MMButton
        type='button'
        size='large'
        variant='elevated'
        collapsed
        collapsedIcon={BellIcon}
        onClick={handleOpen}
        title={tr('FRONTEND.NOTIFICATIONS_PANEL.TITLE', 'Notifications')}
        data-test='notifications-bell'
      />
      {total > 0 && !hideBadge && (
        <span
          className={cn(styles['notifications-badge'], 'notifications-badge')}
          role='status'
          aria-label={tr('FRONTEND.NOTIFICATIONS_PANEL.UNREAD_COUNT', '{{COUNT}} unread').replace(
            '{{COUNT}}',
            String(total)
          )}
          data-test='notifications-badge'
        >
          {total > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : total}
        </span>
      )}
    </div>
  )
}
